import Controls from "../components/Controls";
import RoomPage from "../components/RoomPage";

export default function SalonPage() {
  return <RoomPage roomId="salon" slug="szalon" className="salon-page" heroClassName="salon-room-hero" navigation={<Controls backTo="/tukorterem" nextTo="/szalon/peter" />} />;
}
